module.exports = __webpack_public_path__ + "img/220fe12.jpg";